import React from 'react';
import getFullUrl from '../../utils/formatUrl';

const SuccessMarquee = ({ stories = [] }) => {
    if (stories.length === 0) return null;

    // Duplicate stories for smooth infinite loop
    const marqueeStories = [...stories, ...stories, ...stories, ...stories];

    return (
        <section className="py-24 bg-[#0a0f1a] relative overflow-hidden group">
            {/* Background Accents */}
            <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#cc0000]/5 rounded-full blur-[120px] -mr-64 -mt-64"></div>
            <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-[#003366]/10 rounded-full blur-[120px] -ml-64 -mb-64"></div>

            <div className="max-w-7xl mx-auto px-6 mb-20 relative z-10 flex flex-col md:flex-row md:items-end justify-between gap-8">
                <div>
                    <div className="flex items-center space-x-4 mb-4">
                        <span className="h-px w-12 bg-[#cc0000]"></span>
                        <span className="text-[#cc0000] font-black uppercase text-[10px] tracking-[6px]">Placements 2026</span>
                    </div>
                    <h2 className="text-5xl font-black text-white uppercase tracking-tighter italic leading-none">
                        Driven by <span className="text-[#cc0000] block mt-2">Excellence.</span>
                    </h2>
                </div>
                <div className="bg-white/5 backdrop-blur-md border border-white/10 p-6 rounded-sm max-w-sm">
                    <p className="text-white/60 font-bold text-[10px] uppercase leading-relaxed tracking-widest">
                        Celebrating the achievement of our students who secured high-impact positions at leading global corporations.
                    </p>
                </div>
            </div>
            
            <div className="relative flex overflow-x-hidden">
                <div className="animate-marquee whitespace-nowrap flex py-10">
                    {marqueeStories.map((story, i) => (
                        <div key={i} className="inline-flex items-center mx-2 md:mx-6 bg-slate-900 border-l border-t border-white/10 p-3 md:p-5 rounded-sm shadow-2xl hover:bg-slate-800 transition-all duration-500 min-w-[120px] md:min-w-[340px] group/card relative overflow-hidden">
                            {/* Card Glow */}
                            <div className="absolute inset-0 bg-gradient-to-br from-[#cc0000]/10 to-transparent opacity-0 group-hover/card:opacity-100 transition-opacity duration-500"></div>
                            
                            <div className="w-8 h-8 md:w-16 md:h-16 rounded-sm overflow-hidden border-2 border-white/10 mr-3 md:mr-6 flex-shrink-0 relative z-10">
                                <img 
                                    src={getFullUrl(story.image) || "https://placehold.co/100x100?text=Student"} 
                                    className="w-full h-full object-cover transition-all duration-700 scale-100 group-hover/card:scale-110" 
                                    alt={story.name} 
                                />
                            </div>
                            
                            <div className="flex flex-col relative z-10 min-w-0">
                                <h4 className="text-[10px] md:text-lg font-black text-white uppercase tracking-tighter mb-0.5 md:mb-1 transition-colors group-hover/card:text-[#cc0000] truncate">{story.name}</h4>
                                <div className="space-y-0.5 md:space-y-1">
                                    <div className="flex items-center truncate">
                                        <span className="text-[7px] md:text-[10px] font-black text-[#cc0000] uppercase tracking-widest mr-1 md:mr-2">At:</span>
                                        <span className="text-[8px] md:text-[11px] font-black text-white/80 uppercase truncate">{story.company}</span>
                                    </div>
                                    <div className="flex items-center pt-1 md:pt-2">
                                        <div className="bg-[#cc0000] text-white text-[8px] md:text-[12px] font-black px-1.5 md:px-3 py-0.5 md:py-1 rounded-sm shadow-lg transform -skew-x-12">
                                            <span className="inline-block skew-x-12">{story.package} <span className="hidden md:inline">LPA</span></span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Accent Dot */}
                            <div className="absolute top-2 right-2 md:top-4 md:right-4 w-1 md:h-1.5 md:w-1.5 h-1 bg-[#cc0000] rounded-full animate-pulse"></div>
                        </div>
                    ))}
                </div>
                
                {/* Second loop for seamless transition */}
                <div className="absolute top-0 animate-marquee2 whitespace-nowrap flex py-10">
                    {marqueeStories.map((story, i) => (
                        <div key={i} className="inline-flex items-center mx-2 md:mx-6 bg-slate-900 border-l border-t border-white/10 p-3 md:p-5 rounded-sm shadow-2xl hover:bg-slate-800 transition-all duration-500 min-w-[120px] md:min-w-[340px] group/card relative overflow-hidden">
                            <div className="absolute inset-0 bg-gradient-to-br from-[#cc0000]/10 to-transparent opacity-0 group-hover/card:opacity-100 transition-opacity duration-500"></div>
                            
                            <div className="w-8 h-8 md:w-16 md:h-16 rounded-sm overflow-hidden border-2 border-white/10 mr-3 md:mr-6 flex-shrink-0 relative z-10">
                                <img 
                                    src={getFullUrl(story.image) || "https://placehold.co/100x100?text=Student"} 
                                    className="w-full h-full object-cover transition-all duration-700 scale-100 group-hover/card:scale-110" 
                                    alt={story.name} 
                                />
                            </div>
                            
                            <div className="flex flex-col relative z-10 min-w-0">
                                <h4 className="text-[10px] md:text-lg font-black text-white uppercase tracking-tighter mb-0.5 md:mb-1 transition-colors group-hover/card:text-[#cc0000] truncate">{story.name}</h4>
                                <div className="space-y-0.5 md:space-y-1">
                                    <div className="flex items-center truncate">
                                        <span className="text-[7px] md:text-[10px] font-black text-[#cc0000] uppercase tracking-widest mr-1 md:mr-2">At:</span>
                                        <span className="text-[8px] md:text-[11px] font-black text-white/80 uppercase truncate">{story.company}</span>
                                    </div>
                                    <div className="flex items-center pt-1 md:pt-2">
                                        <div className="bg-[#cc0000] text-white text-[8px] md:text-[12px] font-black px-1.5 md:px-3 py-0.5 md:py-1 rounded-sm shadow-lg transform -skew-x-12">
                                            <span className="inline-block skew-x-12">{story.package} <span className="hidden md:inline">LPA</span></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="absolute top-2 right-2 md:top-4 md:right-4 w-1 md:h-1.5 md:w-1.5 h-1 bg-[#cc0000] rounded-full animate-pulse"></div>
                        </div>
                    ))}
                </div>
            </div>

            <style jsx>{`
                @keyframes marquee {
                    0% { transform: translateX(0); }
                    100% { transform: translateX(-100%); }
                }
                @keyframes marquee2 {
                    0% { transform: translateX(100%); }
                    100% { transform: translateX(0); }
                }
                .animate-marquee {
                    animation: marquee 50s linear infinite;
                }
                .animate-marquee2 {
                    animation: marquee2 50s linear infinite;
                }
                .group:hover .animate-marquee,
                .group:hover .animate-marquee2 {
                    animation-play-state: paused;
                }
            `}</style>
        </section>
    );
};

export default SuccessMarquee;

